import { QuestionTypeChip } from '@exam-management/components';
import { styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@shared/components';

import { CALCULATION_TYPES, DIFFICULTY_LEVELS } from '../../constants';

import { ItemSetQuestionConditionsTableHeader } from './item-set-question-conditions-table-header';

export interface TableData {
  calculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
  notCalculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&:not(:last-of-type)': {
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey[300],
  },
  borderColor: theme.palette.grey[300],
  padding: theme.spacing(2),
  fontWeight: 600,
}));

export interface ItemSetQuestionConditionsTableProps {
  questionConditionsData: Array<{ data: TableData; total?: number }>;
  questionSize: number;
}

export default function ItemSetQuestionConditionsTable(
  props: Readonly<ItemSetQuestionConditionsTableProps>,
) {
  const { questionConditionsData, questionSize } = props;

  return (
    <TableContainer
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        overflow: 'hidden',
        border: '1px solid',
        borderColor: theme.palette.grey[800],
      })}
    >
      <Table
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <ItemSetQuestionConditionsTableHeader />
        <TableBody>
          {questionConditionsData.map(({ data: rowData, total }, rowIndex) => (
            <TableRow key={`item-set-conditions-${rowIndex}`}>
              {rowIndex === 0 ? (
                <StyledTableCell
                  align='center'
                  rowSpan={questionConditionsData.length}
                  sx={{
                    verticalAlign: 'top',
                  }}
                >
                  <QuestionTypeChip type='item-set' questionSize={questionSize} />
                </StyledTableCell>
              ) : null}
              {CALCULATION_TYPES.map((category) => {
                return DIFFICULTY_LEVELS.map((level) => (
                  <StyledTableCell key={level} align='center'>
                    {rowData[category as keyof typeof rowData]?.[
                      level as keyof typeof rowData.calculated
                    ] ?? '-'}
                  </StyledTableCell>
                ));
              })}
              <StyledTableCell
                align='center'
                sx={(theme) => ({
                  bgcolor: theme.palette.grey[100],
                })}
              >
                {total ?? '-'}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
